<template>
  <div>
    <!-- 诊所医生统计卡片区 -->
    <ClinicReportSection :clinic="clinic" :change-slow="changeSlow" :sel-form-fixed="selFormFixed" />
    <!-- 患者统计卡片区 -->
    <PatientReportSection :patient="patient" :change-slow="changeSlow" />
    <!-- 处方营业额统计卡片区 -->
    <FeeCfReportSection :feecf="feecf" :change-slow="changeSlow" />
    <!-- 疾病统计卡片区 -->
    <DiseaseReportSection :disease="disease" />


  </div>
</template>

<script>
import '@/assets/css/main.css';
import moment from "moment-timezone";
// 抽取模块：诊所医生统计卡片
import ClinicReportSection from "./components/ClinicReportSection.vue";
// 抽取模块：患者统计卡片
import PatientReportSection from "./components/PatientReportSection.vue";
// 抽取模块：处方营业额统计卡片
import FeeCfReportSection from "./components/FeeCfReportSection.vue";
// 抽取模块：疾病统计卡片
import DiseaseReportSection from "./components/DiseaseReportSection.vue";

export default {
  name: "ReportHome",
  components: {
    ClinicReportSection,
    PatientReportSection,
    FeeCfReportSection,
    DiseaseReportSection,
  },
  data() {
    return {
      activeName: "first",
      options_province: null,
      options_city: null,
      change_flag: 0,
      changeFast: 3000,
      changeSlow: 5000,
      selForm: {
        // date_span: [moment().subtract(21, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        date_span_zssy: [moment().subtract(60, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        sel_shengqu_zssy: '',
        sel_diban_zssy: '',
      },
      selFormFixed: {
        // date_span: [moment().subtract(21, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        date_span_zssy: [moment().subtract(60, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().subtract(1, 'd').endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        sel_shengqu_zssy: '',
        sel_diban_zssy: '',
      },
      clinic: {},

      patient: {
    "patient_cnt": 16054621,
    "patient_tongbi_cnt": 3083076,
    "patient_tongbi_ratio": "23.77%",
    "patient_male_cnt": 7866297,
    "patient_female_cnt": 8188324,
    "patient_male_ratio": "49.0%",
    "patient_female_ratio": "51.0%",
    "patient_child_cnt": 8179916,
    "patient_aged_cnt": 1723539,
    "patient_child_ratio": "50.95%",
    "patient_aged_ratio": "10.74%",
    "patient_revisit_ratio": "45.88%"
},


      feecf: {},

      disease: {},
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

    }
  },
  mounted() {
    this.get_province();
    this.get_report_data();
    
  },
  methods: {
    get_report_data() {
      // const clinic = await this.$http.post(process.env.VUE_APP_API_HOST + "/api/report/clinic/")
      // this.clinic = clinic.data.data

      this.get_clinic()
      this.get_feecf()
      this.get_patient()
      this.get_disease()

    //   const feecf = await this.$http.post(process.env.VUE_APP_API_HOST + "/api/report/feecf/")
    //   this.feecf  = feecf.data.data

    //  const patient = await this.$http.post(process.env.VUE_APP_API_HOST + "/api/report/patient/")
    //    this.patient  = patient.data.data

    //   const disease = await this.$http.post(process.env.VUE_APP_API_HOST + "/api/report/disease/")
    //    this.disease  = disease.data.data

      // Promise.all([clinic, feecf, patient, disease]).then(res => {
      //   console.log(res)
      // })
      //  this.$store.commit('showLoading', { 
      //   subText: '请稍候...'
      // })
      // this.$http.post(process.env.VUE_APP_API_HOST + "/get_report").then((res) => {
      //   this.clinic = res.data.clinic_report
      //   this.feecf = res.data.feecf_report
      //   this.patient = res.data.patient_report
      //   this.disease = res.data.disease_report
      //   //  this.$store.commit('hideLoading')
      // })
    },
    get_clinic(){
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/report/clinic/").then(res =>{
        this.clinic  = res.data.data
      })
    },
    get_feecf(){
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/report/feecf/").then(res =>{
        this.feecf  = res.data.data
      })
    },
    get_patient(){
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/report/patient/").then(res =>{
        this.patient  = res.data.data
      })
    },
    get_disease(){
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/report/disease/").then(res =>{
        this.disease  = res.data.data
      })
    },
    query() {
      this.change_flag = new Date().getSeconds()
    },
    get_province() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_shengqu").then((res) => {
        this.options_province = res.data.data
      })
    },
    get_city() {
      this.selForm.sel_diban_zssy = ''
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_diban?province_id=" + this.selForm.sel_shengqu_zssy).then((res) => {
        this.options_city = res.data.data
      })

    },
  }
}
</script>

<style scoped>



.information-title {
  color: #19d3ea;
  width: 100%;
  overflow: auto;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
